import * as yup from 'yup';

export const detailsStepSchema = yup.object().shape({
  projectName: yup.string().max(256).required().trim(),
  projectDescription: yup.string().max(1024).required(),
});
